// ./pages/About/index.jsx
import React from "react";
// import Termssubbanner from "../../components/termssubbanner";
import Shopsubbanner from "../../components/shopsubbanner";
import Termsofservice from "../../components/termsofservice";

const Terms = () => {
  return (
    <>
      <Shopsubbanner
        title="Terms of Service"
        image_url="https://res.cloudinary.com/dtivafy25/image/upload/v1749818243/Derby_03_hsjlaz.jpg" />
      <Termsofservice />
    </>
  );
};

export default Terms;